import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedSocialSecurityDocument,
  AddSocialSecurityMutation,
  AddSocialSecurityMutationVariables,
  AddSocialSecurityDocument,
} from "@/graphql/__generated__/graphql";
import { CustomToastComponent } from "@/components/shared";
import { resetPaginationField } from "@/store/paginationStore";

export default function useAddSocialSecurityMutationHook(): { addSocialSecurityMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [addSocialSecurityMutation, { loading, error }] = useMutation<AddSocialSecurityMutation, AddSocialSecurityMutationVariables>(
    AddSocialSecurityDocument, {
      onCompleted() {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedSocialSecurity");

        toast(CustomToastComponent, {
          toastId: "social-security-added-success",
          data: {
            title: t("toasts.socialsecurityaddedsuccessfully"),
            type: "success"
          }
        });
      },
      refetchQueries: [
        {
          query: PaginatedSocialSecurityDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              activeFrom: null,
              value: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addSocialSecurityMutation,
    loading,
    error
  };
}
